import React, { useState , useEffect } from 'react';
import {Link ,useHistory} from "react-router-dom"
// import FacebookIcon from '@material-ui/icons/Facebook';
// import InstagramIcon from '@material-ui/icons/Instagram';
// import TwitterIcon from '@material-ui/icons/Twitter';
// import YouTubeIcon from '@material-ui/icons/YouTube';
// import LinkedInIcon from '@material-ui/icons/LinkedIn';
// import SendIcon from '@material-ui/icons/Send';
// import LocationOnIcon from '@material-ui/icons/LocationOn';
// import PhoneForwardedIcon from '@material-ui/icons/PhoneForwarded';
// import { Flare } from '@material-ui/icons';
// import KeyboardArrowRightSharpIcon from '@material-ui/icons/KeyboardArrowRightSharp';
import logo1 from '../assets/images/logo-kar2.png';
import payment from '../asset1/images/payments.png';

// import FacebookIcon from '@mui/icons-material/Facebook';
  const Footer =(props)=> {
    const [MainCatogories , setMainCategories] = useState([])
    useEffect(() =>{

    fetch("https://zain-ecommerce-main-back.vercel.app/MainCatogories",{
            method: "GET",
             headers :  {
             "Content-Type" : "application/json" , 
         } ,
        })
        .then(res3=>res3.json())
        .then(res4=>{
            let dat = []
            let dat1 = []
            res4.map((res55,c)=>{
              if(c < 10){
                dat.push(res55)
                dat1.push(0)

              }
            })
                        console.log(dat)
            let data = dat.sort((a, b) => {
                return a.sort - b.sort;
            });
            setMainCategories(data)

        })
      },[])

  //  history = useHistory();
  
        return (
            <>
          <footer className="footer footer-2 font-weight-normal second-primary-color" style={{backgroundColor: 'white'}}>
              
              {/* End .cta */}
              <div className="container">
                <hr className="mt-0 mb-0" style={{borderColor: '#444'}} />
              </div>
              <div className="footer-middle border-0">
                <div className="container">
                  <div className="row">
                    
                    {/* End .col-sm-12 col-lg-3 */}


                    <div className="col-12 col-lg-2-5cols">
                      <div className="widget widget-about mb-4">
                        <img src={logo1} className="footer-logo" alt="Footer Logo" width={105} height={25} style={{
                             width: "auto"}}/>
                        <p className="font-weight-normal second-primary-color">Welcome to Viber Cart! Since our establishment in 2009, we've been dedicated to offering a diverse range of products including men's and women's fashion, electronics, books, accessories, sports and outdoor gear, as well as health and beauty products. Count on us to provide top-quality items at the most competitive prices, ensuring your satisfaction every time.
                         </p>
                        <div className="widget-about-info">
                          <div className="row">
                            <div className="col-sm-6 col-md-6">
                              <span className="widget-about-title">Got Question? Call us 24/7</span>
                              <a href="tel:+922132722324" className="text-primary">+92 319-4911846</a>
                            </div>
                            {/* End .col-sm-6 */}
                            {/* <div className="col-sm-6 col-md-6">
                              <span className="pl-3 widget-about-title">Payment Method</span>
                              <figure className="pl-3 mb-0 footer-payments">
                                <img src={payment} alt="Payment" width={272} height={20} />
                              </figure>
                            </div> */}
                            {/* End .col-sm-6 */}
                          </div>
                          {/* End .row */}
                        </div>
                        {/* End .widget-about-info */}
                      </div>
                      {/* End .widget about-widget */}
                    </div>
                    



                    <div className="col-sm-3 col-lg-5cols">
                      <div className="widget mb-4">
                        <h4 className="widget-title">Information</h4>
                        {/* End .widget-title */}
                        <ul className="widget-list">
                          <li>
                            <Link to="/about">About Us</Link>
                          </li>
                          <li>
                            <Link to="/contact">Contact Us</Link>
                          </li>
                          <li>
                            <Link to="/cart">View Cart</Link>
                          </li>
                          <li>
                            <Link to="/whislist">My Wishlist</Link>
                          </li>
                          
                          <li>
                            <Link to="/FAQ">Help</Link>
                          </li>
                        </ul>
                        {/* End .widget-list */}
                      </div>
                      {/* End .widget */}
                    </div>
                    {/* End .col-sm-4 col-lg-3 */}
                  
                    {/* End .col-sm-4 col-lg-3 */}
                    <div className="col-sm-3 col-lg-5cols">
                      <div className="widget mb-4">
                        <h4 className="widget-title">QUICK LINKS</h4>
                        {/* <h4 className="widget-title">My Account</h4> */}
                        {/* End .widget-title */}
                        <ul className="widget-list">
                        
                          <li>
                            <Link to="/term-policy">Terms and conditions</Link>
                          </li>
                          <li>
                            <Link to="/Shipping">Return & Shipping</Link>
                          </li>
                          <li>
                            <Link to="/privacy">Privacy Policy</Link>
                          </li>
                          
                        </ul>
                        
                        {/* End .widget-list */}
                      </div>
                      {/* End .widget */}
                    </div>
                    <div className="col-sm-3 col-lg-5cols">
                      <div className="widget mb-4">
                        <h4 className="widget-title">Categories</h4>
                        {/* <h4 className="widget-title">My Account</h4> */}
                        {/* End .widget-title */}
                        <ul className="widget-list">
                        
                        {MainCatogories.map((res,i)=>{
                   
                   return (
                <>
                    <li>
                      <a href={"/categories/"+res.MainCategories+"/all-products" }>
                         {res.MainCategories}</a>
                    </li>
                 </>
              
              )      
                      
             
            
            })
          

                        }

                        </ul>
                        
                        {/* End .widget-list */}
                      </div>
                      {/* End .widget */}
                    </div>
                    {/* End .col-sm-64 col-lg-3 */}

                    
                  </div>
                  {/* End .row */}
                </div>
                {/* End .container */}
              </div>
              {/* End .footer-middle */}
              <div className="footer-bottom font-weight-normal">
                <div className="container">
                  <p className="font-weight-normal ml-lg-2 second-primary-color" style={{fontSize : "13px", fontWeight :"500"}}>Copyright © 2024 Viber Cart. All Rights Reserved.
                    
                    
                       <a href="https://webocreators.com">Website Development - SEO - GMB Profile - Digital Marketing by Webo Creators</a>
                      <a href="https://gmbbusinessprofileservice.com">GMB Business Profile Setup & Verification Services</a>
                    
                    
                    
                     </p>
                  {/* End .footer-copyright */}
                  {/* <ul className="footer-menu justify-content-center">
                    <li>
                      <a href="#">Terms Of Use</a>
                    </li>
                    <li>
                      <a href="#">Privacy Policy</a>
                    </li>
                  </ul> */}
                  {/* End .footer-menu */}
                  <div className="social-icons social-icons-color justify-content-center">
                    <span className="social-label">Social Media</span>
                    <a href="https://www.facebook.com/profile.php?id=61563055769570" className="social-icon social-facebook" title="Facebook" target="_blank">
                      <i className="icon-facebook-f" />
                    </a>
                    {/* <a href="#" className="social-icon social-twitter" title="Twitter" target="_blank">
                      <i className="icon-twitter" />
                    </a> */}
                    {/* <a href="https://www.instagram.com/" className="social-icon social-instagram" title="Instagram" target="_blank">
                      <i className="icon-instagram" />
                    </a> */}
                    {/* <a href="https://www.youtube.com/channel" className="social-icon social-youtube" title="Youtube" target="_blank">
                      <i className="icon-youtube" />
                    </a> */}
                  </div>
                  {/* End .soial-icons */}
                </div>
                {/* End .container */}
              </div>
              {/* End .footer-bottom */}
            </footer>
            
         



        <a href="https://www.webocreators.com/shopify-website-design-ecommerce-service">Shopify Website Design Ecommerce Service</a> <br/>
<a href="https://www.webocreators.com/facebook-ads-management-service">Facebook Ads Management Service</a> <br/>
<a href="https://www.webocreators.com/google-ads-management-service">Google Ads Management Service</a> <br/>
<a href="https://www.webocreators.com/google-business-profile-service">Google Business Profile Service</a> <br/>
<a href="https://www.webocreators.com/web-development-services">Web Development Services</a> <br/>
<a href="https://www.webocreators.com/graphic-designing-services">Graphic Designing Services</a> <br/>
<a href="https://www.webocreators.com/video-editing-animation-services">Video Editing Animation Services</a> <br/>
<a href="https://www.webocreators.com/social-media-management-services">Social Media Management Services</a> <br/>
<a href="https://www.webocreators.com/mobile-apps-development-services">Mobile Apps Development Services</a> <br/>
<a href="https://www.webocreators.com/ecommerce-web-app-services">Ecommerce Web App Services</a> <br/>
<a href="https://www.webocreators.com/search-engine-optimization-services">Search Engine Optimization Services</a> <br/>
<a href="https://www.webocreators.com/domain-hosting-services">Domain Hosting Services</a> <br/>
<a href="https://www.webocreators.com/brand-identity-design-services">Brand Identity Design Services</a> <br/>
<a href="https://www.webocreators.com/digital-marketing-services">Digital Marketing Services</a> <br/>
<a href="https://www.webocreators.com/ads-management">Ads Management</a> <br/>
<a href="https://www.webocreators.com/aeo-answer-engine-optimization">AEO Answer Engine Optimization</a> <br/>
<a href="https://www.webocreators.com/android-app-design">Android App Design</a> <br/>
<a href="https://www.webocreators.com/app-design">App Design</a> <br/>
<a href="https://www.webocreators.com/app-development">App Development</a> <br/>
<a href="https://www.webocreators.com/brochure-design">Brochure Design</a> <br/>
<a href="https://www.webocreators.com/business-card-design">Business Card Design</a> <br/>
<a href="https://www.webocreators.com/corporate-video-editing">Corporate Video Editing</a> <br/>
<a href="https://www.webocreators.com/custom-thumbnail-design">Custom Thumbnail Design</a> <br/>
<a href="https://www.webocreators.com/custom-website-design">Custom Website Design</a> <br/>
<a href="https://www.webocreators.com/ecommerce-website-mobile-apps">Ecommerce Website Mobile Apps</a> <br/>
<a href="https://www.webocreators.com/flyer-design">Flyer Design</a> <br/>
<a href="https://www.webocreators.com/suspended-google-business-profile-service">Suspended Google Business Profile Service</a> <br/>
<a href="https://www.webocreators.com/verify-gmb">Verify GMB</a> <br/>
<a href="https://www.webocreators.com/service-area-gmb-profile-verification">Service Area GMB Profile Verification</a> <br/>
<a href="https://www.webocreators.com/gmb-profile-creation">GMB Profile Creation</a> <br/>
<a href="https://www.webocreators.com/gmb-profile-optimization">GMB Profile Optimization</a> <br/>
<a href="https://www.webocreators.com/gmb-profile-verification">GMB Profile Verification</a> <br/>
<a href="https://www.webocreators.com/ios-iphone-app-design">iOS iPhone App Design</a> <br/>
<a href="https://www.webocreators.com/local-seo">Local SEO</a> <br/>
<a href="https://www.webocreators.com/logo-design">Logo Design</a> <br/>
<a href="https://www.webocreators.com/meta-ads">Meta Ads</a> <br/>
<a href="https://www.webocreators.com/off-page-seo">Off Page SEO</a> <br/>
<a href="https://www.webocreators.com/on-page-seo">On Page SEO</a> <br/>
<a href="https://www.webocreators.com/ppc-pay-per-click">PPC Pay Per Click</a> <br/>


<a href="https://www.webocreators.com/profile-setup-and-optimization">Profile Setup And Optimization</a> <br/>
<a href="https://www.webocreators.com/react-ecommerce-website">React Ecommerce Website</a> <br/>
<a href="https://www.webocreators.com/shopify-ecommerce-website">Shopify Ecommerce Website</a> <br/>
<a href="https://www.webocreators.com/shopify-website-design">Shopify Website Design</a> <br/>
<a href="https://www.webocreators.com/smm-social-media-management">SMM Social Media Management</a> <br/>
<a href="https://www.webocreators.com/smm-social-media-marketing">SMM Social Media Marketing</a> <br/>
<a href="https://www.webocreators.com/smo-social-media-optimization">SMO Social Media Optimization</a> <br/>
<a href="https://www.webocreators.com/social-media-account-management">Social Media Account Management</a> <br/>
<a href="https://www.webocreators.com/social-media-video-editing">Social Media Video Editing</a> <br/>
<a href="https://www.webocreators.com/technical-seo">Technical SEO</a> <br/>
<a href="https://www.webocreators.com/tiktok-ads">TikTok Ads</a> <br/>
<a href="https://www.webocreators.com/ui-ux-design">UI UX Design</a> <br/>
<a href="https://www.webocreators.com/website-design">Website Design</a> <br/>
<a href="https://www.webocreators.com/website-development">Website Development</a> <br/>
<a href="https://www.webocreators.com/wordpress-ecommerce-website">WordPress Ecommerce Website</a> <br/>
<a href="https://www.webocreators.com/wordpress-website-design">WordPress Website Design</a> <br/>
<a href="https://www.webocreators.com/dropshipping-ecommerce-store">Dropshipping Ecommerce Store</a> <br/>
<a href="https://www.webocreators.com/dropshipping-shopify-marketing">Dropshipping Shopify Marketing</a> <br/>
<a href="https://www.webocreators.com/dropshipping-store-design">Dropshipping Store Design</a> <br/>
<a href="https://www.webocreators.com/e-commerce-marketing">E-Commerce Marketing</a> <br/>
<a href="https://www.webocreators.com/google-maps-promotion">Google Maps Promotion</a> <br/>
<a href="https://www.webocreators.com/google-search-engine-marketing">Google Search Engine Marketing</a> <br/>
<a href="https://www.webocreators.com/instagram-marketing-ads">Instagram Marketing Ads</a> <br/>
<a href="https://www.webocreators.com/landing-page-design">Landing Page Design</a> <br/>
<a href="https://www.webocreators.com/linkedin-profile-optimization">LinkedIn Profile Optimization</a> <br/>
<a href="https://www.webocreators.com/logo-animation">Logo Animation</a> <br/>
<a href="https://www.webocreators.com/menu-design">Menu Design</a> <br/>
<a href="https://www.webocreators.com/packaging-label-design">Packaging Label Design</a> <br/>
<a href="https://www.webocreators.com/responsive-web-design">Responsive Web Design</a> <br/>
<a href="https://www.webocreators.com/search-engine-marketing">Search Engine Marketing</a> <br/>
<a href="https://www.webocreators.com/shopify-marketing">Shopify Marketing</a> <br/>
<a href="https://www.webocreators.com/signage-design">Signage Design</a> <br/>
<a href="https://www.webocreators.com/small-business-marketing-consultant">Small Business Marketing Consultant</a> <br/>



<a href="https://www.webocreators.com/small-business-website-design">Small Business Website Design</a> <br/>
<a href="https://www.webocreators.com/snapchat-ads">Snapchat Ads</a> <br/>
<a href="https://www.webocreators.com/social-media-design">Social Media Design</a> <br/>
<a href="https://www.webocreators.com/tax-consultant">Tax Consultant</a> <br/>
<a href="https://www.webocreators.com/web-developer">Web Developer</a> <br/>
<a href="https://www.webocreators.com/youtube-promotion">YouTube Promotion</a> <br/>
<a href="https://www.webocreators.com/amazon-advertising-agency">Amazon Advertising Agency</a> <br/>
<a href="https://www.webocreators.com/amazon-search-engine-optimization">Amazon Search Engine Optimization</a> <br/>
<a href="https://www.webocreators.com/chatbot-integration">Chatbot Integration</a> <br/>
<a href="https://www.webocreators.com/custom-cms-development">Custom CMS Development</a> <br/>
<a href="https://www.webocreators.com/erp-software-system">ERP Software System</a> <br/>
<a href="https://www.webocreators.com/etsy-store-setup">Etsy Store Setup</a> <br/>
<a href="https://www.webocreators.com/inventory-management-system">Inventory Management System</a> <br/>
<a href="https://www.webocreators.com/local-listings-management">Local Listings Management</a> <br/>
<a href="https://www.webocreators.com/marketplace-website-development">Marketplace Website Development</a> <br/>
<a href="https://www.webocreators.com/multi-vendor-ecommerce-development">Multi Vendor Ecommerce Development</a> <br/>
<a href="https://www.webocreators.com/payment-gateway-integration">Payment Gateway Integration</a> <br/>
<a href="https://www.webocreators.com/saas-software-development">SaaS Software Development</a> <br/>
<a href="https://www.webocreators.com/sales-page-design">Sales Page Design</a> <br/>
<a href="https://www.webocreators.com/software-quality-assurance">Software Quality Assurance</a> <br/>
<a href="https://www.webocreators.com/software-testing-service">Software Testing Service</a> <br/>
<a href="https://www.webocreators.com/subscription-based-ecommerce">Subscription Based Ecommerce</a> <br/>
<a href="https://www.webocreators.com/tax-filing-accounting-service">Tax Filing Accounting Service</a> <br/>
<a href="https://www.webocreators.com/tiktok-content-creation">TikTok Content Creation</a> <br/>
<a href="https://www.webocreators.com/ui-ux-redesign-service">UI UX Redesign Service</a> <br/>
<a href="https://www.webocreators.com/website-maintenance-support">Website Maintenance Support</a> <br/>
<a href="https://www.webocreators.com/woocommerce-website-design">WooCommerce Website Design</a> <br/>




<a href="https://gmbbusinessprofileservice.com/services/additional-google-business-appeal">Additional Google Business Appeal</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/citation-building-services">Citation Building Services</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-location-setup">Google Business Location Setup</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-photo-optimization">Google Business Photo Optimization</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-posts-management">Google Business Posts Management</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-appeal">Google Business Profile Appeal</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-consultation">Google Business Profile Consultation</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-creation">Google Business Profile Creation</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-management">Google Business Profile Management</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-optimization">Google Business Profile Optimization</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-reinstatement">Google Business Profile Reinstatement</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-verification">Google Business Profile Verification</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-maps-promotion">Google Maps Promotion</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-maps-ranking">Google Maps Ranking</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-maps-sponsored-ads">Google Maps Sponsored Ads</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-review-management">Google Review Management</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/local-seo-services">Local SEO Services</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/multi-location-seo">Multi Location SEO</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/service-area-business-verification">Service Area Business Verification</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/suspended-google-business-profile-recovery">Suspended Google Business Profile Recovery</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/affordable-local-seo">Affordable Local SEO</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gbp-profile-setup">GBP Profile Setup</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-agency-near-me">GMB Agency Near Me</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-audit">GMB Audit</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-expert-near-me">GMB Expert Near Me</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-listing-creation">GMB Listing Creation</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-optimization-services-near-me">GMB Optimization Services Near Me</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-review-service">GMB Review Service</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-seo">GMB SEO</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-specialist-near-me">GMB Specialist Near Me</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-listing-creation">Google Business Listing Creation</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-listing-management">Google Business Listing Management</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-listing-optimization">Google Business Listing Optimization</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-listing-support">Google Business Listing Support</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-citations">Google Business Profile Citations</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-for-local-businesses">Google Business Profile For Local Businesses</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-for-online-businesses">Google Business Profile For Online Businesses</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-for-service-area-businesses">Google Business Profile For Service Area Businesses</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-listing-optimization">Google Business Profile Listing Optimization</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-multiple-locations">Google Business Profile Multiple Locations</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-ranking">Google Business Profile Ranking</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-recovery">Google Business Profile Recovery</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-seo">Google Business Profile SEO</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-service-area-business-optimization">Google Business Profile Service Area Business Optimization</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-suspended-help">Google Business Profile Suspended Help</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-verification-issues">Google Business Profile Verification Issues</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-suspension-appeal-not-approved">Google Business Suspension Appeal Not Approved</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-local-ranking">Google Local Ranking</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-maps-citations">Google Maps Citations</a> <br/>


<a href="https://gmbbusinessprofileservice.com/services/additional-google-business-appeal">additional-google-business-appeal</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/citation-building-services">citation-building-services</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-location-setup">google-business-location-setup</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-photo-optimization">google-business-photo-optimization</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-posts-management">google-business-posts-management</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-appeal">google-business-profile-appeal</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-consultation">google-business-profile-consultation</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-creation">google-business-profile-creation</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-management">google-business-profile-management</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-optimization">google-business-profile-optimization</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-reinstatement">google-business-profile-reinstatement</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-verification">google-business-profile-verification</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-maps-promotion">google-maps-promotion</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-maps-ranking">google-maps-ranking</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-maps-sponsored-ads">google-maps-sponsored-ads</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-review-management">google-review-management</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/local-seo-services">local-seo-services</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/multi-location-seo">multi-location-seo</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/service-area-business-verification">service-area-business-verification</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/suspended-google-business-profile-recovery">suspended-google-business-profile-recovery</a> <br/>


<a href="https://urbanrepairksa.com">Urban Repair KSA Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/ac-service.html">AC Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/ac-repairing.html">AC Repair Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/ac-maintenance.html">AC Maintenance Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/ac-fitting.html">AC Fitting Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/ac-gas-filling.html">AC Gas Filling Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/electrician-services.html">Electrician Services Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/home-appliances-repair.html">Home Appliances Repair Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/fridge-freezer-service.html">Fridge Freezer Repair Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/washing-dryer-service.html">Washing Machine & Dryer Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/microwave-oven-repair.html">Microwave Oven Repair Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/led-tv-repair.html">LED TV Repair Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/kitchen-stove-repair.html">Kitchen Stove Repair Service Riyadh</a> <br/>




<a href="https://urbanmoversksa.com">Urban Movers KSA - Professional Moving Services in Riyadh</a> <br/>

<a href="https://urbanmoversksa.com/about">About Urban Movers KSA Moving Company Riyadh</a> <br/>

<a href="https://urbanmoversksa.com/services">Furniture Moving and House Shifting Services in Riyadh</a> <br/>

<a href="https://urbanmoversksa.com/testimonials">Customer Reviews of Urban Movers KSA</a> <br/>

<a href="https://urbanmoversksa.com/contact">Contact Urban Movers KSA for Moving Services in Riyadh</a> <br/>




<a href="https://skycleancleaning.com">شركة سكاي كلين للتنظيف - خدمات تنظيف احترافية في الكويت</a> <br/>

<a href="https://skycleancleaning.com/من-نحن.html">من نحن - شركة سكاي كلين للتنظيف في الكويت</a> <br/>

<a href="https://skycleancleaning.com/خدماتنا.html">خدمات التنظيف للمنازل والشركات في الكويت</a> <br/>

<a href="https://skycleancleaning.com/اتصل-بنا.html">اتصل بشركة سكاي كلين للتنظيف في الكويت</a> <br/>

<a href="https://skycleancleaning.com/الأسعار.html">أسعار خدمات التنظيف في الكويت</a> <br/>

<a href="https://skycleancleaning.com/احجز-الآن.html">احجز خدمة تنظيف في الكويت الآن</a> <br/>

<a href="https://skycleancleaning.com/خدم-بالساعات-في-الكويت.html">خدمات خدم بالساعات في الكويت</a> <br/>

<a href="https://skycleancleaning.com/خدم-بالساعات-في-الكويت.html">عاملات تنظيف بالساعة في الكويت</a> <br/>

<a href="https://skycleancleaning.com/تنظيف-منازل-في-الكويت.html">تنظيف منازل في الكويت</a> <br/>

<a href="https://skycleancleaning.com/ارقام-خدم-بالساعات-حولي.html">أرقام خدم بالساعات في حولي</a> <br/>

<a href="https://skycleancleaning.com/خدم-بالساعات-الكويت-انستقرام.html">خدم بالساعات الكويت انستقرام</a> <br/>

<a href="https://skycleancleaning.com/شركة-تنظيف-الكويت.html">أفضل شركة تنظيف في الكويت</a> <br/>







<a href="https://tameerinternational.com">شركة تعمير الدولية للمقاولات والتركيب في الكويت</a> <br/>

<a href="https://tameerinternational.com/feature">مميزات شركة تعمير الدولية للخدمات</a> <br/>

<a href="https://tameerinternational.com/من-نحن.html">من نحن - شركة تعمير الدولية الكويت</a> <br/>

<a href="https://tameerinternational.com/feature.html">أفضل خدمات التركيب والتصميم في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا.html">خدمات شركة تعمير الدولية للمقاولات</a> <br/>

<a href="https://tameerinternational.com/اتصل-بنا.html">تواصل مع شركة تعمير الدولية الكويت</a> <br/>

<a href="https://tameerinternational.com/آراء-العملاء.html">آراء عملاء شركة تعمير الدولية</a> <br/>

<a href="https://tameerinternational.com/نموذج-الحجز.html">احجز خدمات التركيب في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تجديد-وتنجيد-الجلسات-الخارجية.html">تجديد وتنجيد الجلسات الخارجية في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-أسوار-حديد-وخشب.html">تركيب أسوار حديد وخشب في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-بوابات-حديد-حديثة.html">تركيب بوابات حديد حديثة الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-درابزين-حديد-للأسطح-والسلالم.html">تركيب درابزين حديد للأسطح والسلالم</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-ساندوتش-بانل-الكويت.html">تركيب ساندوتش بانل في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-سواتر-حديدية.html">تركيب سواتر حديدية في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-سواتر-خشبية-للأسطح-والمنازل.html">تركيب سواتر خشبية للمنازل والأسطح</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مخازن-ساندوتش-بانل.html">تركيب مخازن ساندوتش بانل الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مظلات-بولي-كربونيت-شفافة.html">تركيب مظلات بولي كربونيت شفافة</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مظلات-حدائق-حديد-في-الكويت.html">تركيب مظلات حدائق حديد في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مظلات-حدائق-وسيارات.html">تركيب مظلات حدائق وسيارات</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مظلات-سيارات-حديد-في-الكويت.html">تركيب مظلات سيارات حديد الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مظلات-سيارات-متحركة-اوتوماتيكية-في-الكويت.html">تركيب مظلات سيارات متحركة أوتوماتيكية</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مظلات-قماش-PVC.html">تركيب مظلات قماش PVC في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مظلات-كلادينج.html">تركيب مظلات كلادينج الكويت</a> <br/>





            </>
        )
    
}

export default Footer;